export default __webpack_public_path__ + "static/media/mortyworld.5cc6444a.png";